module.exports = __webpack_public_path__ + "static/media/predict.102ec777.svg";